export default {
	skySelect: () => import('./sky-select.vue'),
	skyAsyncSelect: () => import('./sky-asyncSelect.vue'),
	skyCustomSelect: () => import('./sky-customSelect.vue'),
	skyDatePicker: () => import('./sky-date-picker.vue'),
	skyDateRange: () => import('./sky-date-range.vue'),
	skyInput: () => import('./sky-input.vue'),
	skyRadio: () => import('./sky-radio.vue'),
	skyCheckbox: () => import('./sky-checkbox.vue'),
	skyTel: () => import('./sky-tel.vue'),
	skyTextarea: () => import('./sky-textarea.vue'),
	skyFilterSelect: () => import('./sky-filterSelect.vue'),
	skyDropdownSelect: () => import('./sky-dropdownSelect.vue'),
	skyRangeInput: () => import('./sky-rangeInput.vue'),
	skyCondition: () => import('./sky-condition.vue'),
	skySortSelect: () => import('./sky-sortSelect.vue'),
	skyMainInput: () => import('./sky-mainInput.vue'),
	skyCascade: () => import('./sky-cascade'),
	skyCascader: () => import('./sky-cascader'),
	skyBothInput: () => import('./sky-bothInput'),
	skySwitch: () => import('./sky-switch'),
	skySpan: () => import('./sky-span'),
	skyInputNumber: () => import('./sky-input-number'),
	skyNewInput: () => import('./sky-testInput'),
	skyUploadImg: () => import('./sky-uploadimg'),
	skyImgRotate: () => import('./sky-img-rotate'),
	skyMedia: () => import('./account/sky-media'),
	customerSearch: () => import('./account/customerSearch.vue'),
	skyOrderInquiry: () => import('./sky-order-inquiry'),
	skyLine: () => import('./sky-line'),
	skyLineText: () => import('./sky-line-text'),
	serviceCode: () => import('./serviceCode/serviceCode.vue'),
	skyText: () => import('./sky-text.vue'),
	skyVenify: () => import('./sky-venify.vue'),
	skyRichtext: () => import('./sky-richtext.vue'),
	skyUeditor: () => import('./sky-ueditor.vue'),
	skyProgress: () => import('./sky-progress.vue'),
	skyThumbnail: () => import('./sky-thumbnail.vue'),
	skyInputPrepend: () => import('./sky-input-prepend.vue'),
	skyDatePickerPrepend: () => import('./sky-date-picker-prepend.vue'),
	skySliderExtent: () => import('./sky-slider-extent.vue'),
	skyInputExtent: () => import('./sky-input-extent.vue'),
	skyAddInput: () => import('./sky-add-input.vue'),
	skyCardCascadePanel: () => import('./sky-card-cascade-panel.vue'), // 卡片级联
	skySelectCard: () => import('./sky-select-card.vue'), // 自定义card边框
	skyAlert: () => import('./sky-alert.vue'), // 自定义item项
	skyInputButton: () => import('./sky-input-button.vue'),
	skyPhoneAreaCode: () => import('./sky-phone-areaCode.vue'), // 带区号选择的号码输入框
};
